/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from './loader.service';
import { Subscription } from 'rxjs';
import { CommonService } from '../../shared/services/common.service';
import { CompensationAnalyticsService } from '../../shared/services/analytics.service';
import { AuditLogsSerivce } from '../../shared/services/audit-logs.service';
import { GenealogyService } from '../../shared/services/genealogy.service';
import { AuditLogReportService } from '../../components/fieldsupport/audit-log-report/audit-log-report.service';
import { TieredCompensationsService } from '../../shared/services/tieredCompensations.service';
import { DistributorOrdersService } from '../../components/fieldsupport/distributorOrders/distributorOrders.service';
import { PaymentsService } from '../../shared/services/payments.service';
import { IntegrationAuditSerivce } from 'app/shared/services/integrationAudit.service';
import { InboundLogReportService } from 'app/shared/services/inbound-log-report.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnDestroy {
  public loaderDisplay = false;
  public subscription: Subscription;
  public cancelDisplay = false;
  public cancelSubscription: Subscription;

  constructor(private _loaderService: LoaderService, private auditLogsSerivce: AuditLogsSerivce,
    private analyticsService: CompensationAnalyticsService, private changeDetectorRef: ChangeDetectorRef,
    private tieredCompensationsService:TieredCompensationsService,
    private distributorOrdersService:DistributorOrdersService,
    private commonService: CommonService,
    private genealogyService: GenealogyService,
    private paymentsService:PaymentsService,
    private auditLogReportService:AuditLogReportService,
    private integrationAuditSerivce: IntegrationAuditSerivce,
    private inboundLogReportService: InboundLogReportService) {
    this.subscription = this._loaderService.isLoaderVisible.subscribe(val => {
      this.loaderDisplay = val;
      this.changeDetectorRef.detectChanges();
    }, error => {
      console.log(error);
    }, () => {
      console.log('completed');
    });

    this.cancelSubscription = this._loaderService.isDisplayCancelVisible.subscribe(val => {
      this.cancelDisplay = val;
    }, error => {
      console.log(error);
    }, () => {
      console.log('completed');
    })
  }

  public getTranslationWithKey(key: string): string{
    return this.commonService.getTranslatedVal(key);
  }

  public cancelRequest(): void {
    console.log('Cancel request clicked');
    this.analyticsService.cancelRequest(true);
    this.auditLogsSerivce.cancelRequest(true);
    this.genealogyService.cancelRequest(true);
    this.tieredCompensationsService.cancelRequest(true);
    this.distributorOrdersService.cancelRequest(true);
    this.paymentsService.cancelRequest(true);
    this.auditLogReportService.cancelRequest(true);
    this.integrationAuditSerivce.cancelRequest(true);
    this.inboundLogReportService.cancelRequest(true);
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

}
